/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { FormState, FormStateBuilder } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { isNull } from 'lodash';
import {
  HousePlanFinderBusinessService,
  HousePlanFinderDialogConfig,
} from '../../resources/house-plan-finder-business.service';
import {
  DEFAULT_HOUSE_PLAN_FILTER,
  getHousePlanId,
  HousePlanFinderListItem,
} from '../../resources/house-plan-finder.model';
import { HousePlanFinderGridDefinition } from './house-plan-finder-grid-definition.service';

@Component({
  selector: 'gh-house-plan-finder-dialog',
  template: require('./house-plan-finder-dialog.component.html'),
  styles: [require('./house-plan-finder-dialog.component.scss')],
  providers: [HousePlanFinderGridDefinition],
})
export class HousePlanFinderDialogComponent
  extends AbstractFinderDialogComponent<HousePlanFinderDialogConfig, HousePlanFinderListItem>
  implements OnInit {

  form: FormState<any>;
  getId = getHousePlanId;

  defaultTitle = this.translations.get('lbl_find_hp');

  constructor(public gridDefinition: HousePlanFinderGridDefinition,
              private translations: TranslationService,
              private formStateBuilder: FormStateBuilder,
              private dialogRef: MatDialogRef<any>,
              private businessService: HousePlanFinderBusinessService) {
    super(dialogRef);
  }

  get disableShowQqSwitcher(): any {
    return isNull(this.input.disableShowQqSwitcher) ? false : this.input.disableShowQqSwitcher;
  }

  get disableShowSeSwitcher(): any {
    return isNull(this.input.disableShowSeSwitcher) ? false : this.input.disableShowSeSwitcher;
  }

  get sourceOfficeId(): ID {
    return this.input.sourceOfficeId;
  }

  ngOnInit(): void {
    const { sourceOfficeId } = this;

    this.form = this.formStateBuilder.buildPlain({
      value: { ...DEFAULT_HOUSE_PLAN_FILTER, sourceOfficeId },
      children: {
        searchString: void 0,
        quickQuote: { enabled: !this.disableShowQqSwitcher },
        salesEstimate: { enabled: !this.disableShowSeSwitcher },
        sourceOfficeId: void 0,
      },
    });

    super.ngOnInit();
  }

  protected buildDataSource(): SlicedDataSource<HousePlanFinderListItem> {
    return this.businessService.findAllAsDataSource({ ...this.form.submitValue, ...this.input.filter });
  }
}
